var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoseImageActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 736,
    width: 64,
    height: 32,
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 256,
    width: 64,
    height: 64,
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1024H1024V0ZM960,864a32,32,0,0,1-32,32H224a32,32,0,0,1-32-32V768H796a36,36,0,0,0,36-36V256h96a32,32,0,0,1,32,32Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960,288V864a32,32,0,0,1-32,32H224a32,32,0,0,1-32-32V768H796a36,36,0,0,0,36-36V256h96A32,32,0,0,1,960,288Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1024H1024V0ZM960,864a32,32,0,0,1-32,32H224a32,32,0,0,1-32-32V768H796a36,36,0,0,0,36-36V256h96a32,32,0,0,1,32,32Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "577.85 704 128 704 128 557.05 368 456 577.85 704",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "768 524 768 704 650.67 704 569.57 606.68 768 524",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796,128H100a36,36,0,0,0-36,36V732a36,36,0,0,0,36,36H796a36,36,0,0,0,36-36V164A36,36,0,0,0,796,128ZM128,704v-147L368,456,577.85,704Zm640,0H650.67l-81.1-97.32L768,524Z",
    style: {
      fill: "#0057d9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 320,
    r: 64,
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoseImageActive);
export default __webpack_public_path__ + "static/media/pose_image_active.4fc3df8d736148d620b231c649d8a4ad.svg";
export { ForwardRef as ReactComponent };